// extracted by mini-css-extract-plugin
export var cardSelected = "_gz-2";
export var image = "_gz-1";
export var table = "_gz-0";